<template>
  <!-- Modal Component -->
  <b-modal :id="modalRef" centered :ref="modalRef"  size="lg"
  :title="title">
    <b-container class="text-center">
      <div class="mb-2">Detalls*:</div>
      <TextEditor class="mb-3" @updateDetails="childVal => {
          this.details = childVal.details
        }"/>
      <b-row>
        <b-col v-if="checkTicketEditable(this.user, this.ticket) && this.checkManagerInGroup(this.user, this.ticket.grup.id)">
          <div class="mb-2">Dedicació:</div>
          <b-form-select class="mb-3" v-model="hores" :options="temps_dedicat_select">
            <template slot="first">
              <option value=null disabled>-- Selecciona una quantitat de temps --</option>
            </template>
          </b-form-select>
        </b-col>
        <b-col>
          <div class="mb-2">Data i hora:</div>
          <div class="mx-auto mb-3">
            <Datetime
            type="datetime"
            value-zone="local"
            v-model="actionDatetime"
            :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
            :phrases="{ok: 'Acceptar', cancel: 'Sortir'}"
            title="Escull una data i una hora"
            :week-start="1"/>
          </div>
        </b-col>
        <b-col>
          <div class="mb-2">Fitxers:</div>
          <AddFiles class="mb-2" @updateFiles="childVal => {
              this.files = childVal.files
            }"/>
        </b-col>
      </b-row>
      <b-form-checkbox v-if="checkTicketEditable(this.user, this.ticket) && this.checkManagerInGroup(this.user, this.ticket.grup.id)"
        v-model="private_action">
        Només visible a gestors
      </b-form-checkbox>
    </b-container>
    <div slot="modal-footer" class="w-100">
      <b-btn v-if="this.transition !== 'cancel' && this.ticket.estat.nom === 'active' && checkTicketEditable(this.user, this.ticket) && this.checkManagerInGroup(this.user, this.ticket.grup.id)"
      class="float-left" variant="danger" size="sm" @click.prevent="save(true)">
        <font-awesome-icon :icon="['fas', 'exclamation-circle']"/>
        Desar i tancar
      </b-btn>
      <b-btn size="sm" class="float-right" variant="primary" @click.prevent="save()">
        <font-awesome-icon :icon="['fas', 'check']"/>
        Desar
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import AddFiles from '@/components/AddFiles'
import TextEditor from '@/components/TextEditor'
import moment from 'moment'
import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'

Settings.defaultLocale = 'cat'

export default {
  components: {
    Datetime,
    AddFiles,
    TextEditor
  },
  computed: {
    temps_dedicat () {
      return this.$store.state.dedicated_times
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  data () {
    var dades = this.getDefaultData()
    dades['temps_dedicat_select'] = []
    return dades
  },
  props: {
    title: {
      required: true,
      Type: String
    },
    ticket: {
      required: true,
      type: Object
    },
    transition: {
      required: false,
      Type: String
    },
    modalRef: {
      required: false,
      Type: String,
      default: function () {
        return 'modalAddAction'
      }
    }
  },
  methods: {
    getDefaultData () {
      return {
        // Información escogida por el usuario
        hores: null,
        details: null,
        actionDatetime: moment().format(),
        files: '',
        private_action: false
      }
    },
    save (close) {
      if (this.isNullOrUndefined(this.details)) {
        this.notifyError('Falta informació', 'El camp detalls es necessari')
      } else {
        var formData = new FormData()
        formData.append('ticket_id', this.ticket.id)
        formData.append('description', this.details)
        formData.append('user', this.user.id)
        formData.append('actionDatetime', this.actionDatetime)
        if (this.private_action === true) {
          formData.append('private', true)
        }

        if (!this.isNullOrUndefined(this.hores)) {
          formData.append('dedicatedTime', this.hores)
        }

        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i]
          formData.append(file.name, file)
        }

        this.$refs[this.modalRef].hide()
        if (this.transition || close) {
          if (['reactivate', 'addedinfo', 'cancel'].includes(this.transition)) {
            formData.append('transition', this.transition)
          } else if (close) {
            formData.append('transition', 'close')
          }
        }

        this.$store.dispatch('createAction', formData)

        // Reiniciamos el modal
        Object.assign(this.$data, this.getDefaultData())
      }
    }
  },
  created () {
    this.$store.dispatch('fetchHoresDedicades').then(() => {
      this.temps_dedicat_select = this.temps_dedicat.map(temps =>
        ({
          value: temps.id,
          text: temps.descripcio
        }))
      return this.temps_dedicat_select
    }, {})
  }
}
</script>
